import { get } from '../api';
import { useLoad } from '../hooks';

interface Summary {
  id: number;
  name: string;
  tasks: number;
  job_types?: string[];
}
interface Detail {
  groups: { name: string; tasks: { title: string }[] }[];
}

/**
 * Choose which checklist an assignment's visits use, and show what is on it. 0 means the
 * default one: the default for the first of the assignment's types of work that has one.
 */
export function ChecklistPicker(props: {
  label: string;
  value: number;
  /** The assignment's types of work, in order. */
  jobTypes?: string[];
  onChange(id: number): void;
}) {
  const list = useLoad(() => get<{ items: Summary[] }>('/api/checklists?state=active'), []);
  const items = Array.isArray(list.data?.items) ? list.data!.items : [];
  const byType = (props.jobTypes ?? [])
    .map((j) => items.find((c) => (c.job_types ?? []).includes(j)))
    .find((c) => c !== undefined);
  const shown = props.value > 0 ? props.value : (byType?.id ?? 0);
  const detail = useLoad(
    () => (shown > 0 ? get<Detail>(`/api/checklists/${shown}`) : Promise.resolve(null)),
    [shown],
  );
  const groups = detail.data && Array.isArray(detail.data.groups) ? detail.data.groups : [];

  return (
    <div>
      <select
        aria-label={props.label}
        value={props.value}
        onChange={(e) => props.onChange(Number(e.target.value))}
      >
        <option value={0}>
          {byType ? `Default for its type of work: ${byType.name}` : 'Default checklist'}
        </option>
        {items.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name} ({c.tasks} tasks)
          </option>
        ))}
      </select>
      {groups.length > 0 && (
        <div className="preview-box" aria-label="Tasks on this checklist">
          {groups.map((g, i) => (
            <div key={`${g.name}-${i}`}>
              {g.name && <strong>{g.name}</strong>}
              <ul>
                {g.tasks.map((t) => (
                  <li key={t.title}>{t.title}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
